import { makeResource } from '@/lib/api/resources';
import { api } from '@/lib/api/client';
import type { BlockSchemaRegistry, ProductFamily } from '@/lib/api/types';

/**
 * Product Families resource (spec §9.2). Bespoke typed collection that shares the standard
 * CRUD + publish/unpublish surface. Per the spec, delete is gated on `content:write` (not
 * `content:delete`); publish/unpublish require `content:publish`. The factory matches the
 * `/admin/product-families` route family.
 */
export const familiesApi = {
  ...makeResource<ProductFamily>('/admin/product-families'),

  /**
   * Collection `doc` JSON Schemas (GET /admin/collection-schemas). The backend owns the
   * canonical shape of the rich `doc` blob; the family rich-content editor is generated from
   * the `product_family` entry so the form, server validation, and the website never drift.
   */
  collectionSchemas(): Promise<BlockSchemaRegistry> {
    return api.get<BlockSchemaRegistry>('/admin/collection-schemas');
  },
};
